import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'W16',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M29.15 13.7c.42.6.75 1.26 1 1.96h.01-2.99a5.43 5.43 0 0 0-4.71-2.72c-1.09 0-2.1.33-2.95.88-.84-3.62-4.07-6.33-7.94-6.33-4.51 0-8.17 3.66-8.17 8.17H.68c0-6.02 4.88-10.89 10.89-10.89 1.36 0 2.67.26 3.87.71C16.56 2.29 19.58 0 23.15 0c.51 0 1.02.05 1.5.14a5.45 5.45 0 0 0 6.53 6.53c.09.49.14.99.14 1.5 0 2.13-.83 4.07-2.17 5.53zM21.93 2.86a5.438 5.438 0 0 0-4.03 3.93c1.3.93 2.4 2.15 3.19 3.56.45-.08.91-.14 1.38-.14 1.78 0 3.43.58 4.77 1.55.58-.67 1.01-1.48 1.22-2.37a8.186 8.186 0 0 1-6.53-6.53zM2.04 18.38h27.23c.75 0 1.36.61 1.36 1.36s-.61 1.36-1.36 1.36H2.04c-.75 0-1.36-.61-1.36-1.36s.61-1.36 1.36-1.36zm0 5.45h27.23c.75 0 1.36.61 1.36 1.36 0 .75-.61 1.36-1.36 1.36H2.04c-.75 0-1.36-.61-1.36-1.36s.61-1.36 1.36-1.36zm0 5.45h27.23c.75 0 1.36.61 1.36 1.36S30.03 32 29.28 32H2.04c-.75 0-1.36-.61-1.36-1.36s.61-1.36 1.36-1.36z" }
      })]
    );
  }
};